/* eslint-disable import/no-anonymous-default-export */
export default (stock = [], action) => {
  switch (action.type) {
    case "GET_ALL_STOCKS":
      return action.payload;
    case "CREATE_STOCK":
      return [...stock, action.payload];

    default:
      return stock;
  }
};
